import type { GuardianContactCardProps } from './GuardianContactCard'

/** The card display fields sourced from a canonical `guardianContact` slice. */
export type GuardianContactCardFields = Pick<
  GuardianContactCardProps,
  'contactNotAvailable' | 'firstName' | 'lastName' | 'dateOfBirth' | 'email' | 'phone' | 'relationshipToPatient'
>

/**
 * Map a canonical `guardianContact` slice onto the `GuardianContactCard`
 * display fields. Both OrderStart and OrderInProgress render the standalone
 * (non primary-guardian-comparator) guardian card from the same canonical
 * fields, so this keeps that mapping in one place; behavioral props
 * (`onEdit`, `needsAttention`, status) stay at the call site.
 */
export function guardianContactCardFieldsFromCanonical(
  guardianContact?: GuardianContactCardFields | null
): GuardianContactCardFields {
  return {
    contactNotAvailable: guardianContact?.contactNotAvailable,
    firstName: guardianContact?.firstName,
    lastName: guardianContact?.lastName,
    dateOfBirth: guardianContact?.dateOfBirth,
    email: guardianContact?.email,
    phone: guardianContact?.phone,
    relationshipToPatient: guardianContact?.relationshipToPatient,
  }
}
